<nb-card>
  <nb-card-body>
    <div class="event-card">
      <button nbButton shape="round">{{ type }}</button>
      <h3>{{ title }}</h3>
      <time>
        <nb-icon icon="calendar-outline"></nb-icon>
        {{ date }}
      </time>
      <p>
        <nb-icon icon="pin-outline"></nb-icon>
        {{ local }}
      </p>
    </div>
  </nb-card-body>
</nb-card>
